import { render, staticRenderFns } from "./SCardSimpleInfo.vue?vue&type=template&id=052e710c"
import script from "./SCardSimpleInfo.vue?vue&type=script&lang=js"
export * from "./SCardSimpleInfo.vue?vue&type=script&lang=js"
import style0 from "./SCardSimpleInfo.vue?vue&type=style&index=0&id=052e710c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports